/*
  Winkelwagen-lade - eigen gedrag bovenop Dawn (03-09-2026).

  Twee taken:
    1. Upsells ophalen bij Shopify's eigen aanbevelingen-endpoint en toevoegen
       aan de winkelwagen zonder paginaherlaad.
    2. De lade automatisch openen in de Theme Editor zodra de sectie wordt
       geselecteerd, zodat je niet naar een dichte lade zit te kijken.

  Het kortingscodeveld is op 06-09-2026 verwijderd (PK): de checkout heeft een
  eigen "Korting toevoegen"-knop en dat is genoeg. De bijbehorende code
  (applyDiscount, /discount/{code}, de feedbackregel) is in dezelfde beurt
  opgeruimd, inclusief het bloktype in de schema van sections/cart-drawer.liquid.

  Alle winkelwagen-mutaties lopen via Dawn's bestaande Section Rendering
  API-aanpak, zodat de lade, het totaal en het winkelwagen-icoon in een keer
  bijwerken - geen eigen renderlogica.
*/

(function () {
  'use strict';

  const SECTIONS_TO_REFRESH = ['cart-drawer', 'cart-icon-bubble'];

  function drawerElement() {
    return document.querySelector('cart-drawer');
  }

  /* ---------- Winkelwagen opnieuw renderen ---------- */

  async function refreshDrawer() {
    const drawer = drawerElement();
    if (!drawer) return;

    const url = `${window.location.pathname}?sections=${SECTIONS_TO_REFRESH.join(',')}`;
    const response = await fetch(url);
    if (!response.ok) return;

    const sections = await response.json();

    const drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const fresh = parsed.querySelector('#CartDrawer');
      const current = document.querySelector('#CartDrawer');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', fresh.closest('cart-drawer')?.classList.contains('is-empty') ?? false);
      }
    }

    const bubbleHtml = sections['cart-icon-bubble'];
    if (bubbleHtml) {
      const bubble = document.querySelector('#cart-icon-bubble');
      const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const fresh = parsed.querySelector('.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }

    loadUpsells();
  }

  /* ---------- 1. Upsells ----------

    De suggesties worden server-side gerenderd vanuit de collectie(s) van de
    producten in de winkelwagen (zie snippets/biscomi-cart-upsells.liquid).
    Hier hoeft dus alleen de carousel opgestart te worden.
  */

  function loadUpsells() {
    const container = document.querySelector('[data-biscomi-upsells]');
    if (!container) return;

    const body = container.querySelector('[data-biscomi-upsells-body]');
    if (!body) return;

    setupCarousel(container, body);
  }

  /* ---------- Beloningsbalk: vloeiend vullen ----------

    De balk komt uit Liquid met breedte 0% en het doelpercentage in
    data-progress. Hier zetten we de breedte een frame later op dat doel,
    zodat de CSS-overgang loopt (PK, 04-09-2026).

    Bij een aantalwijziging bouwt de lade zichzelf opnieuw op. We onthouden
    daarom het vorige percentage en beginnen de nieuwe animatie daar, zodat de
    balk verder vult of juist leegloopt in plaats van vanaf nul te herbeginnen.
  */

  let lastProgress = null;

  function animateRewardsBar() {
    const track = document.querySelector('[data-biscomi-rewards-track]');
    if (!track) return;

    const target = parseFloat(track.dataset.progress || '0');
    if (track.dataset.animatedTo === String(target)) return;

    const start = lastProgress === null ? 0 : lastProgress;

    track.style.transition = 'none';
    track.style.backgroundSize = start + '% 100%';

    requestAnimationFrame(() => {
      track.style.transition = '';
      track.style.backgroundSize = target + '% 100%';
      track.dataset.animatedTo = String(target);
      lastProgress = target;
    });
  }

  /*
    Carousel: er is altijd een suggestie in beeld. De lijst is een flexrij waarin
    elk item de volle breedte krijgt; verschuiven gebeurt met een transform.
    De pijlen verschijnen alleen bij meer dan een suggestie.
  */
  function setupCarousel(container, body) {
    const list = body.querySelector('.biscomi-upsells__list');
    const items = list ? list.querySelectorAll('.biscomi-upsells__item') : [];
    const prev = container.querySelector('[data-biscomi-upsell-prev]');
    const next = container.querySelector('[data-biscomi-upsell-next]');
    if (!list || items.length === 0) return;

    /*
      Zonder dit slot zou de bewaker die de lade in de gaten houdt zichzelf
      blijven aanroepen: de carousel past het scherm aan, dat telt als
      wijziging, en dan begint het opnieuw. Na een echte herbouw van de lade is
      dit een vers element zonder markering, dus dan start hij wel weer op.
    */
    if (list.dataset.biscomiCarousel === 'ready') return;
    list.dataset.biscomiCarousel = 'ready';

    const multiple = items.length > 1;
    if (prev) prev.hidden = !multiple;
    if (next) next.hidden = !multiple;
    if (!multiple) {
      list.style.transform = 'translateX(0)';
      return;
    }

    let index = 0;
    const render = () => {
      list.style.transform = `translateX(-${index * 100}%)`;
    };

    const step = (delta) => {
      index = (index + delta + items.length) % items.length;
      render();
    };

    if (prev) prev.onclick = () => step(-1);
    if (next) next.onclick = () => step(1);

    render();
  }

  async function handleUpsellSubmit(form) {
    const button = form.querySelector('button[type="submit"]');
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    const originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = '...';
    }

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] }),
      });

      if (!response.ok) throw new Error('toevoegen mislukt');
      await refreshDrawer();
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  }

  /* ---------- 2. Gedelegeerde events ---------- */

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-biscomi-upsell-form]');
    if (!form) return;
    event.preventDefault();
    handleUpsellSubmit(form);
  });

  /*
    Opstarten van de carousel - bewust langs DRIE wegen (PK, 04-09-2026).

    Dawn roept na een winkelwagen-wijziging alle geabonneerde scripts na elkaar
    aan. Gaat er een onderweg stuk, dan komen de scripts erna niet meer aan de
    beurt. Dat gebeurde hier: de Koin-app zoekt naar Upcart's element, dat in
    dit thema niet meer bestaat, en gooit een fout. Onze carousel werd daardoor
    nooit opgestart en de suggestie verscheen half afgeknipt.

    Daarom kijken we ook zelf of de lade van inhoud verandert. Dat werkt
    ongeacht wat andere apps doen.
  */

  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => refreshModules());
  }

  function refreshModules() {
    loadUpsells();
    animateRewardsBar();
  }

  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.biscomiWatched === 'true') return;
    drawer.dataset.biscomiWatched = 'true';

    const observer = new MutationObserver(() => {
      // Meerdere wijzigingen achter elkaar leiden tot een enkele herstart.
      clearTimeout(watchDrawer.timer);
      watchDrawer.timer = setTimeout(refreshModules, 50);
    });

    observer.observe(drawer, { childList: true, subtree: true });

    /*
      Openen van de lade verandert alleen de klassen op <cart-drawer>, niet de
      inhoud. Daar kijken we apart naar, zodat de balk ook bij openen vult in
      plaats van al gevuld in beeld te komen (PK, 04-09-2026).
    */
    const openObserver = new MutationObserver(() => {
      if (!drawer.classList.contains('active')) {
        // Bij sluiten resetten, zodat de volgende keer weer vanaf 0 vult.
        const track = document.querySelector('[data-biscomi-rewards-track]');
        if (track) delete track.dataset.animatedTo;
        lastProgress = null;
        return;
      }
      animateRewardsBar();
    });

    openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    refreshModules();
    watchDrawer();
  }

  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();

  /* ---------- 4. Theme Editor: lade openen bij selectie ---------- */

  if (window.Shopify && window.Shopify.designMode) {
    /*
     * Alleen openen als de selectie ECHT bij de lade hoort. De block-listener
     * deed dit eerder onvoorwaardelijk, waardoor elk willekeurig blok (bv. de
     * variantkiezer op de productpagina) de lade liet openspringen tijdens het
     * bewerken. Gefixt 05-09-2026 — editor-only gedrag, klanten merkten hier
     * niets van.
     */
    const belongsToDrawer = (element) => {
      if (!element) return false;
      const drawer = drawerElement();
      if (drawer && drawer.contains(element)) return true;
      const section = typeof element.closest === 'function' ? element.closest('.shopify-section') : null;
      return !!(section && section.id && section.id.indexOf('cart-drawer') !== -1);
    };

    const openDrawer = (event) => {
      if (!belongsToDrawer(event.target)) return;
      const drawer = drawerElement();
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };

    document.addEventListener('shopify:section:load', () => {
      loadUpsells();
    });
    document.addEventListener('shopify:section:select', openDrawer);
    document.addEventListener('shopify:block:select', openDrawer);
  }
})();
